import Vue from 'vue';
import '@/addons.ts';
import VueGtm from 'vue-gtm';
import Raven from '@/modules/raven';
import App from './App.vue';
import router from './router/index';
import * as stores from '@/stores/index';
import VueI18n from 'vue-i18n';
import languages from './languages';
import { getUserLanguage } from './modules/language';
import { localize } from 'vee-validate';
import AsyncComputed from 'vue-async-computed';
Vue.use(AsyncComputed);
Vue.use(VueI18n);

const locale = getUserLanguage();
const i18n = new VueI18n({
  locale,
  messages: languages, // set locale messages
});
localize(locale);

const authStore = stores.auth;

// GTM は Vue インスタンス生成より前に一度だけ初期化する
// （router.afterEach 内だと初回 PV が落ちたり、$gtm が不安定になる）
const gtmId = process.env.VUE_APP_GTM_ID;
if (gtmId) {
  Vue.use(VueGtm, {
    id: gtmId,
    vueRouter: router,
    enabled: true,
    debug: process.env.NODE_ENV !== 'production',
  });
}

authStore.initial(() => {
  new Vue({
    router,
    render: (h) => h(App),
    async beforeCreate() {
      console.log(this.$stores.auth.state.uid);
      Raven.initial();
    },
    i18n,
  }).$mount('#app');
});
